import type {
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import type { AddPacketProps, Packet } from '@/types/packet'

import { addPacket } from './services/mutatePackets'
import { invalidateLoadPackets } from './useLoadPackets'

type Props = {
  addPacket: (data: AddPacketProps) => Promise<Packet>
  isLoading: boolean
} & UseMutationResult<Packet, Error, AddPacketProps>

export const useAddPackets = (
  options: UseMutationOptions<Packet, Error, AddPacketProps> = {}
): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.PACKETS.ADD],
    mutationFn: async (data: AddPacketProps) => await addPacket(data),
    onSuccess: async () => {
      await invalidateLoadPackets()
    },
    ...options,
  })

  const addPacketReq = async (data: AddPacketProps) => {
    return mutation.mutateAsync(data)
  }

  return {
    addPacket: addPacketReq,
    ...mutation,
  }
}
